import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ConfigProvider } from 'antd';
import { legacyLogicalPropertiesTransformer, StyleProvider } from '@ant-design/cssinjs';
import zhCN from 'antd/lib/locale/zh_CN';

declare global {
    interface Window {
        useCompatibilityModal: () => void;
    }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <ConfigProvider locale={zhCN}>
        <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
            <App />
        </StyleProvider>
    </ConfigProvider>
);
